const WrapperEditable = require('./wrapper.editable');
const Base = require('./mobile');
const createEditable = require('../../adapters/createEditable');
const { getCarouselProps } = require('./getProps');

module.exports = createEditable(WrapperEditable(Base), getCarouselProps);
